import { render, staticRenderFns } from "./main.reportes.vue?vue&type=template&id=f47161e6"
import script from "./main.reportes.vue?vue&type=script&lang=js"
export * from "./main.reportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports